import { useRef, useEffect, useState } from "react";
import M from "materialize-css";

export const useAutocomplete = (onAutocomplete) => {
  const ref = useRef(null);

  const setData = (data) => {
    const el = ref.current;
    const instance = M.Autocomplete.getInstance(el);
    instance.updateData(data);
  };

  useEffect(() => {
    const el = ref.current;
    const options = { onAutocomplete, limit: 5 };
    const instance = M.Autocomplete.init(el, options);

    return () => {
      if (instance) {
        instance.destroy();
      }
    };
  }, [ref]);

  return { ref, setData };
};
